/* eslint-disable no-undef */
import Vue from 'vue';
import Router from 'vue-router';
import result from './result';
import singleResult from './singleResult';
import consultant from './consultant';
import common from './common';
import growupLine from './growupLine';
import overtime from './overtime';
import store from '@/store';
import {handleGlobalAuthInfo} from '@threegene/common-js/xdm/auth/token.ctrl';
import {statistics} from '@js/config/index';
import {urtLogin} from '@js/util/urt/index';

let isInit = false;

const router = new Router({
  mode: 'history',
  base: process.env.ROUTER_BASE,
  routes: [...result, ...singleResult, ...consultant, ...common, ...growupLine, ...overtime]
});
// 初始化鉴权参数
const initAuth = async () => {
  if (!isInit) {
    isInit = true;
    const {tokenOfEnv, userInfo = {}} = await handleGlobalAuthInfo();
    store.commit('global/SET_TOKEN_ENV', tokenOfEnv);
    store.commit('global/SET_USERINFO', userInfo);

    const userInfoStore = store.getters['global/userInfo'];
    if (store.getters['global/token']) {
      // 重新获取用户信息
      if (!userInfoStore.id) {
        await store.dispatch('global/getUserInfo').catch();
      }
    }
    if (userInfoStore.id) {
      statistics.login();
      urtLogin(userInfoStore.id);
    }
  }
};

// 全局守卫
router.beforeEach(async (to, from, next) => {
  await initAuth();
  if (!document.title) {
    if (to.meta.title) {
      document.title = to.meta.title.title;
    }
  }
  const xdmRegp = /xdm/g;
  if (xdmRegp.test(window.navigator.userAgent)) {
    // 设置全局title
    to.meta.title && sdk.setTitle(to.meta.title);
    // 判断页面是否可以分享
    sdk.forbidShare(to.name === 'result');
  }
  next();
});

router.afterEach((to) => {
  if (to.meta.title) {
    document.title = to.meta.title.title;
  }
});

Vue.use(Router);

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js